import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

type DeveloperAreaProps = {
  developerInformation: string
}

const DeveloperArea = ({ developerInformation }: DeveloperAreaProps) => {
  if (!developerInformation) return null

  return (
    <Box alignItems="flexStart" justifyContent="flexStart">
      <Box paddingBottom="s8">
        <Text size="400" weight="medium" color="grey1000">
          {i18n.t('marketplace.developer_area.title')}
        </Text>
      </Box>

      <Text size="300" color="grey800" overflowWrap>
        {developerInformation}
      </Text>
    </Box>
  )
}

export default DeveloperArea
